import { useRouteMatch } from 'react-router';

import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { Scroll } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { ReferralToHospitalPanelLoader } from './ReferralToHospitalPanel.loader';
import { ReferralToHospitalRouteLeavingGuard } from './ReferralToHospitalRouteLeavingGuard';
import { ElectronicReferralToHospitalSendAction } from './ReferralToHospitalSendAction/ElectronicReferralToHospitalSendAction';
import { ReferralToHospitalSendAction } from './ReferralToHospitalSendAction/ReferralToHospitalSendAction';
import { ReferralToHospitalForm } from './ReferralToHsopitalForm/ReferralToHospitalForm';

type ReferralToHospitalPanelProps = {
   readonly visit: Visit;
};

export const ReferralToHospitalPanel = (props: ReferralToHospitalPanelProps): JSX.Element => {
   const electronic = Boolean(useRouteMatch({ path: visitPaths.ELECTRONIC_REFERRAL_TO_HOSPITAL_PATH }));
   return (
      <Scroll testId={'referralToHospital'}>
         <ReferralToHospitalPanelLoader visitId={props.visit.id} electronic={electronic}>
            {({ referralToHospitalDraft }) => (
               <ReferralToHospitalForm
                  referralToHospitalDraft={referralToHospitalDraft}
                  visitDiagnoses={props.visit.diagnoses}
                  visitBeginDate={props.visit.beginDate}
                  electronic={electronic}
                  visitId={props.visit.id}
               >
                  {({ handleSubmit, handleSubmitDraft, formState, reset, trigger }) => (
                     <>
                        {electronic ? (
                           <ElectronicReferralToHospitalSendAction
                              visitId={props.visit.id}
                              patientId={props.visit.patient.id}
                              handleSubmit={handleSubmit}
                              onSuccess={reset}
                              trigger={trigger}
                           />
                        ) : (
                           <ReferralToHospitalSendAction
                              visitId={props.visit.id}
                              handleSubmit={handleSubmit}
                              onSuccess={reset}
                           />
                        )}

                        <ReferralToHospitalRouteLeavingGuard
                           formState={formState}
                           visitId={props.visit.id}
                           handleSubmitDraft={handleSubmitDraft}
                           electronic={electronic}
                        />
                     </>
                  )}
               </ReferralToHospitalForm>
            )}
         </ReferralToHospitalPanelLoader>
      </Scroll>
   );
};
